<flyfreely-map
    #map
    airspaceCheckResult
    class="fill"
    [organisationId]="currentOrganisation?.id"
    [features]="features$ | async"
    [featurePopupTemplate]="featurePopupTemplate"
    [showFeatureSelection]="false"
    [collapseMapStyles]="viewMode === 'MAP'"
    [requireCtrlToZoom]="false"
    [isDashboardMap]="true"
    [crosshairCursor]="awaitingFeature"
    [dashboardMode]="missionViewService.viewMode$ | async"
    [ignoreClicksOnFeatureGroups]="ignoreClicksOnFeatureGroups"
    [startTime]="airspaceValue?.startTime"
    [endTime]="airspaceValue?.endTime"
    [ruleset]="airspaceValue?.airspaceRuleset"
    [mapData]="mapData$ | async"
    [enableLayerGroupsByDefault]="['LOTAM', 'MISSIONS']"
    (featureSelected)="onFeatureSelected($event)"
    (mapReady)="onMapReady()"
    (measurementToolSelected)="onMeasurementToolSelected()"
    (editModeChanged)="onEditModeChanged($event)"
    (featureClusterSelected)="onFeatureClusterSelected($event)"
    (fullscreenRequested)="onFullscreenRequested()"
    (featureUnselected)="onFeatureUnselected()"
    (jurisdictionChanged)="onUpdateJurisdiction($event)"
    (mapClick)="onMapClicked($event)"
    (viewportChange)="onViewportChange($event)"
>
    <ng-template *ngIf="viewMode === 'BOTH'" mapSidebar let-map="map">
        <map-airspace-checker
            [organisationId]="organisationId"
            [timeZone]="this.currentTimeZone"
            [flightArea]="flightArea"
            [workTracker]="workTracker"
            [jurisdiction]="map.jurisdictionChanged | async"
            [head]
            emptyStateMessage="Click the map point to check"
            [allowMissionCreation]="canAddMission"
            [dashboardCheckerMode]="missionViewService.viewMode$ | async"
            [allowDrawing]="true"
            [radius]="checkerAreaRadius"
            (checkerParametersChange)="onCheckerParametersChanged($event)"
            (createMission)="createMissionFromChecker()"
            (requestToggleFullscreen)="onFullscreenRequested()"
            (awaitingFeature)="setAwaitingFeature($event)"
            (clearFlightArea)="clearFlightArea()"
            (hasCheckResult)="onAirspaceCheckStatusChange($event)"
        ></map-airspace-checker>
    </ng-template>

    <ng-template *ngIf="viewMode === 'MAP'" mapToolbar let-map="map">
        <div class="horizontal-container" style="margin-bottom: -10px">
            <div
                class="input-group"
                btnRadioGroup
                [(ngModel)]="timeSelection"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="handleOperationsViewTime()"
            >
                <label
                    class="btn btn-pill"
                    [ngClass]="{
                        'btn-lg': !reduceButtonSizes,
                        'btn-sm': reduceButtonSizes
                    }"
                    [btnRadio]="'TODAY'"
                    [disabled]="working"
                    tooltip="View missions scheduled for today"
                    placement="top"
                    analyticsOn
                    analyticsAction="update-time-filter"
                    analyticsCategory="daily-operations"
                    analyticsLabel="TODAY"
                    >Today</label
                >
                <label
                    class="btn btn-pill"
                    [ngClass]="{
                        'btn-lg': !reduceButtonSizes,
                        'btn-sm': reduceButtonSizes
                    }"
                    [btnRadio]="'+2'"
                    [disabled]="working || !canUseAdvancedDailyOperations"
                    tooltip="View missions scheduled over the next 3 days (today and the next two days)"
                    placement="top"
                    analyticsOn
                    analyticsAction="update-time-filter"
                    analyticsCategory="daily-operations"
                    analyticsLabel="+2"
                    ><upsell-lock
                        *ngIf="!canUseAdvancedDailyOperations"
                    ></upsell-lock
                    >+2 Days</label
                >
                <label
                    class="btn btn-pill"
                    [ngClass]="{
                        'btn-lg': !reduceButtonSizes,
                        'btn-sm': reduceButtonSizes
                    }"
                    [btnRadio]="'+7'"
                    [disabled]="working || !canUseAdvancedDailyOperations"
                    tooltip="View missions scheduled for the next week"
                    placement="top"
                    analyticsOn
                    analyticsAction="update-time-filter"
                    analyticsCategory="daily-operations"
                    analyticsLabel="+7"
                    ><upsell-lock
                        *ngIf="!canUseAdvancedDailyOperations"
                    ></upsell-lock
                    >+7 Days</label
                >
            </div>
            <form [formGroup]="dateRangeForm">
                <button
                    type="button"
                    class="btn btn-pill"
                    [ngClass]="{
                        'btn-lg': !reduceButtonSizes,
                        'btn-sm': reduceButtonSizes,
                        active: timeSelection === 'CUSTOM'
                    }"
                    [disabled]="working || !canUseAdvancedDailyOperations"
                    #dateRangeSelection="bs-popover"
                    [popover]="dateRangeSelectionPopover"
                    container=""
                    [outsideClick]="true"
                    [adaptivePosition]="true"
                    placement="top"
                    tooltip="Set a custom date range to filter missions"
                    analyticsOn
                    analyticsAction="update-time-filter"
                    analyticsCategory="daily-operations"
                    analyticsLabel="CUSTOM"
                >
                    <upsell-lock
                        *ngIf="!canUseAdvancedDailyOperations"
                    ></upsell-lock>
                    Custom Date
                </button>
                <ng-template #dateRangeSelectionPopover>
                    <div class="contents bottom-buffer">
                        <div class="input-group">
                            <input
                                type="text"
                                class="btn btn-lg btn-pill"
                                readonly
                                #datePicker="bsDaterangepicker"
                                bsDaterangepicker
                                placeholder="Custom date range"
                                [bsConfig]="{ adaptivePosition: true }"
                                placement="top"
                                [container]="'body'"
                                formControlName="customDateRange"
                                (bsValueChange)="searchCustomDate($event)"
                                class="form-control"
                                [ngClass]="{
                                    'input-clear-active':
                                        dateRangeForm.value.customDateRange
                                }"
                            />
                            <span
                                *ngIf="dateRangeForm.value.customDateRange"
                                class="input-group-addon input-group-clear calendar"
                                (click)="
                                    dateRangeForm.controls.customDateRange.reset()
                                "
                            >
                                <i class="fal fa-times"></i>
                            </span>
                            <span
                                class="input-group-addon btn-default"
                                (click)="datePicker.toggle()"
                                [attr.aria-expanded]="datePicker.isOpen"
                            >
                                <i class="glyphicon glyphicon-calendar"></i>
                            </span>
                        </div>
                    </div>
                </ng-template>
            </form>
            <button
                *ngIf="canFilterByAuthority"
                type="button"
                class="btn btn-pill"
                [ngClass]="{
                    'btn-lg': !reduceButtonSizes,
                    'btn-sm': reduceButtonSizes
                }"
                [disabled]="working || !canUseAdvancedDailyOperations"
                #authoritySelection="bs-popover"
                [popover]="authoritySelectionPopover"
                container=""
                [outsideClick]="true"
                [adaptivePosition]="true"
                placement="top"
                tooltip="Update the mission authority filters for the visible missions"
                analyticsOn
                analyticsAction="update-authority-filter"
                analyticsCategory="daily-operations"
            >
                <upsell-lock
                    *ngIf="!canUseAdvancedDailyOperations"
                ></upsell-lock>
                Authorities
            </button>
            <ng-template #authoritySelectionPopover>
                <div class="contents bottom-buffer">
                    <label class="no-wrap">Mission Organisation:</label>
                    <ng-select
                        class="mission-organisation-select"
                        [items]="missionAuthorityFilters$ | async"
                        [formControl]="organisationSelector"
                        [clearable]="false"
                        appendTo="body"
                        bindLabel="name"
                    >
                        <ng-template
                            ng-option-tmp
                            ng-label-tmp
                            let-item="item"
                            let-index="index"
                            ><span class="ng-option-label" [title]="item.name">
                                {{ item.name }}
                            </span>
                        </ng-template>
                    </ng-select>
                    <label>Mission Authority:</label>
                    <ng-select
                        [items]="(organisationSelectorValue$ | async)?.children"
                        [formControl]="authoritySelector"
                        [clearable]="false"
                        appendTo="body"
                        bindLabel="name"
                    >
                        <ng-template
                            ng-option-tmp
                            ng-label-tmp
                            let-item="item"
                            let-index="index"
                            ><span
                                class="ng-option-label"
                                [title]="
                                    item.isPrimary
                                        ? item.name + ' - Primary'
                                        : item.name
                                "
                            >
                                {{ item.name }}
                                <span
                                    *ngIf="item.isPrimary"
                                    class="status-block inverted custom"
                                    >Primary</span
                                >
                            </span>
                        </ng-template>
                    </ng-select>
                </div>
            </ng-template>
            <button
                type="button"
                class="btn btn-pill"
                [ngClass]="{
                    'btn-lg': !reduceButtonSizes,
                    'btn-sm': reduceButtonSizes
                }"
                [disabled]="working"
                (click)="showMissionTableWithCurrent()"
                tooltip="View the mission list table for the currently visible missions"
                placement="top"
            >
                View Missions
            </button>
            <button
                *ngIf="
                    missionReportTemplates &&
                    missionReportTemplates.length === 1
                "
                type="button"
                class="btn btn-pill"
                [ngClass]="{
                    'btn-lg': !reduceButtonSizes,
                    'btn-sm': reduceButtonSizes
                }"
                [disabled]="working || !canUseAdvancedDailyOperations"
                (click)="
                    runMissionReport(missionReportTemplates[0].reportTemplateId)
                "
                tooltip="Run a mission list report for the currently visible missions"
                placement="top"
            >
                <upsell-lock
                    *ngIf="!canUseAdvancedDailyOperations"
                ></upsell-lock>
                Briefing Report
            </button>
            <div
                *ngIf="
                    missionReportTemplates && missionReportTemplates.length > 1
                "
                class="btn-group"
                dropdown
                [dropup]="true"
            >
                <button
                    id="reports-button-container"
                    dropdownToggle
                    type="button"
                    class="btn btn-pill btn-lg dropdown-toggle"
                    aria-controls="dropdown-container"
                    [disabled]="working || !canUseAdvancedDailyOperations"
                >
                    Briefing Reports
                    <span class="caret"></span>
                </button>
                <ul
                    *dropdownMenu
                    id="reports-dropdown-container"
                    class="dropdown-menu dropdown-menu-right"
                    role="menu"
                    aria-labelledby="reports-button-container"
                >
                    <li
                        role="menuitem"
                        *ngFor="let report of missionReportTemplates"
                    >
                        <a
                            class="dropdown-item"
                            (click)="runMissionReport(report.reportTemplateId)"
                            >{{ report.name }}</a
                        >
                    </li>
                </ul>
            </div>

            <upsell-button
                *ngIf="!canUseAdvancedDailyOperations"
                [buttonClasses]="reduceButtonSizes ? 'btn-sm' : 'btn-lg'"
                tooltipPlacement="top"
                text="Upgrade for Filtering and Reporting"
            ></upsell-button>
        </div>
    </ng-template>
</flyfreely-map>
<inline-modal
    *ngIf="
        airspaceJurisdiction &&
        airspaceJurisdiction.airspaceDisclaimer &&
        airspaceJurisdiction.airspaceDisclaimer.length
    "
    [show]="showAirspaceDisclaimer"
    [sizeSmall]="true"
    [topSpacing]="true"
    style="max-height: fit-content"
>
    <airspace-disclaimer
        screenIdentifier="mission-view-map"
        [airspaceJurisdiction]="airspaceJurisdiction"
        (done)="onAirspaceDisclaimerAcknowledged()"
    ></airspace-disclaimer>
</inline-modal>
<ng-template #featurePopupTemplate>
    <loading-indicator [isLoading]="working"></loading-indicator>
    <h4 class="popup-title" *ngIf="selectedLocation != null">
        Missions at {{ selectedLocation.name }}
    </h4>
    <div class="popup-panel">
        <div *ngIf="selectedMissions != null">
            <div *ngFor="let mission of selectedMissions">
                <h5>
                    <mission-status-icon
                        [mission]="mission"
                        (nameClicked)="showMission(mission)"
                    ></mission-status-icon>
                </h5>
                <p>
                    {{ mission.missionDate | formatDate }}
                    {{ mission.status | formatMissionStatus }}
                </p>
            </div>
            <div *ngIf="selectedMissions.length === 0">
                There are no missions at this location
            </div>
        </div>
    </div>
</ng-template>
